import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { animate, style, transition, trigger } from '@angular/animations';

interface CancelReason {
  value: string;
  label: string;
}

@Component({
  selector: 'app-trip-cancellation-dialog',
  templateUrl: './trip-cancellation-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    TranslateModule
  ],
  animations: [
    trigger('slideInTop', [
      transition(':enter', [
        style({ transform: 'translateY(-10px)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ])
    ])
  ]
})
export class TripCancellationDialogComponent {
  selectedReason = '';
  customReason = '';
  readonly maxLength = 200;

cancelReasons: CancelReason[] = [
  { value: 'drivers not found', label: 'TRIP.CANCEL.REASONS.DRIVERS_NOT_FOUND' },
  { value: 'change of plans', label: 'TRIP.CANCEL.REASONS.CHANGE_PLANS' },
  { value: 'wrong information', label: 'TRIP.CANCEL.REASONS.WRONG_INFO' },
  { value: 'other', label: 'TRIP.CANCEL.REASONS.OTHER' }
];

  constructor(
    public dialogRef: MatDialogRef<TripCancellationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get isConfirmDisabled(): boolean {
    return (
      !this.selectedReason ||
      (this.selectedReason === 'other' && !this.customReason.trim())
    );
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.isConfirmDisabled) return;
    const reason =
      this.selectedReason === 'other' ? this.customReason : this.selectedReason;
    this.dialogRef.close({ reason });
  }
}
